(() => {
  const selector = '.hdt-okendo-card-rating .oke-sr-count';
  let scheduled = false;

  const formatCounts = () => {
    scheduled = false;
    document.querySelectorAll(selector).forEach((count) => {
      const card = count.closest('.hdt-okendo-card-rating');
      const label = card?.dataset.reviewCountLabel;
      const match = count.textContent.trim().match(/\d[\d\s.,]*/);
      if (!label || !match) return;
      const formatted = label.replace('__count__', match[0].trim());
      if (count.textContent.trim() !== formatted) count.textContent = formatted;
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(formatCounts);
  };

  const start = () => {
    schedule();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
